import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnChanges,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth';

@Directive({ selector: '[appHasAny]' })
export class HasAnyDirective implements OnChanges {
  private tpl = inject(TemplateRef<any>);
  private vcr = inject(ViewContainerRef);
  private auth = inject(AuthService);
  private sub?: Subscription;
  private rendered = false;

  @Input('appHasAny') required: string[] = [];

  constructor() {
    this.sub = this.auth.permissionsChanges.subscribe(() => this.update());
  }

  ngOnChanges() {
    this.update();
  }

  private update() {
    const canShow =
      this.required.length === 0 || this.auth.hasAny(this.required);
    if (canShow && !this.rendered) {
      this.vcr.clear();
      this.vcr.createEmbeddedView(this.tpl);
      this.rendered = true;
    } else if (!canShow && this.rendered) {
      this.vcr.clear();
      this.rendered = false;
    }
  }
}
